import React, {Component} from 'react';
import WaitingModal from '../generics/WaitingModal';
import {translate} from 'react-i18next';
import { Table, Button } from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import { search } from 'react-icons-kit/icomoon/search';
import Moment from 'react-moment';
import { download3 } from 'react-icons-kit/icomoon/download3';
import { cross } from 'react-icons-kit/icomoon/cross';
import {print} from 'react-icons-kit/fa/print';
import swal from 'sweetalert';
import ModalView from './modalView';
import ModalStatus from './modalStatus';
import Help from '../generics/help';

import SvgIcon from 'react-icons-kit';
var Config = require('../../config');

class Distribution extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.editUnitOrder = this.editUnitOrder.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onPrint = this.onPrint.bind(this);

		this.state = {
			submenu: "",
			results: [],
			filterText:"",
			start_date:"",
			end_date:"",
			start_folio:"",
			end_folio:"",
			option:"",
			status:"all_except",
			columns:[],
		}
	}

	componentDidMount(){	    
		var submenu = this.state.submenu === "" ? this.props.match.path.replace('/', '') : this.state.submenu;
		this.setState({submenu: submenu});
		
		this.onSearch();

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=UNIT_REQUEST',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => response.json())
      	.then(response => {
        	if(response !== undefined){
          		this.setState({ columns: response });
        	}
      	});

	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	onSearch(e){
		if(e !== undefined)
			e.preventDefault();

		if(this.state.status === ""){
			swal('¡Error!', "Seleccione un estatus", 'error');
			return;
		}else{
			this.waiting_modal.handleShow("Cargando...");
			fetch(Config.default.apiGateway.URL+'unit_request?start_date='+this.state.start_date+
					'&end_date='+this.state.end_date+'&start_folio='+this.state.start_folio+'&end_folio='+this.state.end_folio+
					'&option='+this.state.option+'&health_facilities_id='+sessionStorage.getItem('health_facilities_id')+
					'&type=requested_by&status='+this.state.status, {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Conten-Type'	: 'application/json'
				})
			}).then(res =>{
				this.waiting_modal.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			})
			.then(response=>{
				if(response !== undefined){
					
					this.setState({results: response});
					if(this.state.status === "all_except")
						this.setState({status: ""});
				}
					
			});
		}
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.unit.id !== null &&
				row.unit.unit_number !== null &&
				row.blood_component.component !== null &&
				row.blood_component.code !== null &&
				row.unit.volume !== null &&
				row.status !== null
			){

				if(
					row.unit.id.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.unit_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.component.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.blood_component.code.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.component_number.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.unit.volume.indexOf(this.state.filterText.toUpperCase()) !== -1  ||
					row.status.indexOf(this.state.filterText.toUpperCase()) !== -1 
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	handleChange(e){
		this.setState({[e.target.name]: e.target.value});
	}

	editUnitOrder(id){
		this.props.history.push("/distribution/orderUnits/"+id);
	}

	confirmOrder(id){
		this.props.history.push("/confirm/"+id);
	}

	changeStatus(id, status){
		this.modal_status.handleShow(id, status);
	}

	viewDetails(title, id){
		this.modal_view.handleShow(title, id);
	}

	async onPrint(id, type, e){
    	e.preventDefault();

		this.waiting_modal.handleShow('Imprimiendo...');
          
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;
		obj.file_type = type;
		obj.nEtiqueta = [0];
		obj.option = 'hemored';

		var type = await this.props.getDocumentType(obj.file_type);

		
		var document;
		if(type !== undefined){
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
	
			if(document !== undefined){
				this.waiting_modal.handleClose();
				this.setState({ show: false});
			}else{
				this.waiting_modal.handleClose();
			}
		}else{
			this.waiting_modal.handleClose();
		}
		
  	}

  	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}


	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						Inicio -> 
						Distribución ->
						Pedido de Unidades
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_distribution"} 
	                submenu={"help_unit_request"}  />
		                
				<form noValidate>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input className="form-control" type="date" name="start_date" id="start_date"
								onKeyPress={(e) => this.validateInput(e)} 
								onChange={this.handleChange} value={this.state.start_date || ""} autoFocus={true} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input className="form-control" type="date" name="end_date" id="end_date" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.end_date || ""}  />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Desde</span>
							<input className="form-control" type="text" name="start_folio" id="start_folio" 
								onKeyPress={(e) => this.validateInput(e)}
								onChange={this.handleChange} value={this.state.start_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Folio Hasta</span>
							<input className="form-control" type="text" name="end_folio" id="end_folio"
								onKeyPress={(e) => this.validateInput(e)} 
								onChange={this.handleChange} value={this.state.end_folio || ""} />
						</div>
						<div className={"col-xs-12 col-sm-2"}>
							<span className="span-min">Estatus</span>
			                <select className="form-control" name="status" id="status" value={this.state.status || ""}
			                  onChange={this.handleChange}>
			                  <option value="" disabled >Seleccionar...</option>
			                  <option value="all">TODOS</option>
			                  <option value="CANCELADA">CANCELADA</option>
			                  <option value="ENVIADO">ENVIADO</option>
			                  <option value="PENDIENTE">PENDIENTE DE ENVÍO</option>
			                  <option value="RECIBIDA">RECIBIDA</option>
			                  <option value="RECHAZADA">RECHAZADA</option>
			                  <option value="SUMINISTRADO">SUMINISTRADO</option>
			                </select>
			            </div>	
			            <div className="col-xs-12 col-sm-1" style={{marginTop:"10.5px"}}>
							<Button className="btn btn-info" title="Buscar" style={{fontSize:"1em"}} 
								onClick={(e)=>this.onSearch(e)}>
								Buscar
							</Button>
						</div>			
						<div className="col-xs-12 col-sm-1" style={{marginTop:"10.5px"}}>
							<Button className="btn btn-info" title="Nuevo" style={{fontSize:"1em"}} 
								disabled={!this.props.task_unit_request.create}
								onClick={this.editUnitOrder.bind(this,"-1")}>
								Nuevo
							</Button>
						</div>
					</div>
				</form>

				<hr style={{width:"95%"}} />

				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={this.showColumn('ID')}>Id</th>
								<th hidden={this.showColumn('FOLIO')}>Folio</th>
								<th hidden={this.showColumn('REQUEST_TO')}>Solicitado a</th>
								<th hidden={this.showColumn('COMPONENTS')}>Componentes</th>
								<th hidden={this.showColumn('AMOUNT')}>Cant. Tot.</th>
								<th hidden={this.showColumn('STATUS')}>Estatus</th>
								<th hidden={this.showColumn('DATE')}>Fecha y Hora</th>
								<th hidden={this.showColumn('CONTROLS')}></th>
							</tr>
						</thead>

						<tbody>
		                 	{this.state.results.map( (item, index) => (
			                    <tr key={item.unit_request.id}>
			                      	<td hidden={this.showColumn('ID')}>{item.unit_request.id}</td>
			                      	<td hidden={this.showColumn('FOLIO')}>{item.unit_request.folio}</td>
									<td hidden={this.showColumn('REQUEST_TO')}>{item.request_to.name}</td>
									<td hidden={this.showColumn('COMPONENTS')}>{item.components}</td>
									<td hidden={this.showColumn('AMOUNT')}>{item.amount}</td>
									<td hidden={this.showColumn('STATUS')}>{item.status === "PENDIENTE" ? "PENDIENTE DE ENVÍO" : item.status}</td>
									<td hidden={this.showColumn('DATE')}><Moment format="DD/MM/YYYY">{item.unit_request.date}</Moment> - {item.unit_request.hour}</td>
									<td hidden={this.showColumn('CONTROLS')}>
										
										<Button className="btn btn-info btn-xs" title="Ver" style={{marginRight:"5px"}}
											onClick={this.viewDetails.bind(this,'Pedido de Unidades', item.unit_request.id)}>
											<SvgIcon icon={search} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Imprimir Petición" style={{marginRight:"5px"}}
											//disabled={item.status !== 'SUMINISTRADO'}
											onClick={(e)=>this.onPrint(item.unit_request.id, 'unit_petitions', e)}>
											<SvgIcon icon={print} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Imprimir Envío" style={{marginRight:"5px"}}
											disabled={item.status === 'PENDIENTE DE ENVÍO' || item.status === 'ENVIADO'}
											onClick={(e)=>this.onPrint(item.unit_request.id, 'unit_export_hemored', e)}>
											<SvgIcon icon={print} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
											disabled={(item.status !== 'PENDIENTE') || !this.props.task_unit_request.update}
											onClick={this.editUnitOrder.bind(this,item.unit_request.id)}>
											<SvgIcon icon={pencil2} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Confirmar" style={{marginRight:"5px"}}
											disabled={item.status !== 'SUMINISTRADO' && item.status !== 'SURTIDO INCOMPLETO'} onClick={this.confirmOrder.bind(this,item.unit_request.id)}>
											<SvgIcon icon={download3} />
										</Button>
										<Button className="btn btn-info btn-xs" title="Retirar" style={{marginRight:"5px"}}
											disabled={item.status !== 'ENVIADO' || !this.props.task_unit_request.delete}
											onClick={this.changeStatus.bind(this,item.unit_request.id, item.status)}>
											<SvgIcon icon={cross} />
										</Button>
									</td>
			                    </tr>
		                    ))}
		                </tbody>
					</Table>
				</div>

				<ModalStatus {...this.props} onSearch={this.onSearch} handleChange={this.handleChange} onRef={ref => (this.modal_status = ref)}/>
				<ModalView {...this.props} onRef={ref => (this.modal_view = ref)}/>
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Distribution)
